import { useState, useEffect, MouseEvent } from "react";
import { usePodcastProvider, PodcastConfig } from "../PodcastProvider";
import { useInterval } from "hooks";
import { withMediaProps } from "react-media-player";
import port from "services/port";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui

import { Button } from "@chakra-ui/react";
import { CancelIcon, PauseIcon, PlayIcon, PlayFillIcon } from "components/icons";
import { MediaProps } from "./CustomMediaSlider";
import PodcastColorTypes from "types/podcastColorTypes";

interface PlayPauseProps {
  media?: MediaProps;
  handlePlayPodcast?: () => void;
  cancel?: boolean;
  podcastDetails?: PodcastConfig;
  size?: string;
  expandedPlay?: boolean;
}

function TogglePlayPause({ media, handlePlayPodcast, cancel, podcastDetails, size = "48px", expandedPlay }: PlayPauseProps) {
  const { playingPodcast, setPlayingPodcast, playPodcast, setPlayPodcast } = usePodcastProvider();

  const [second, setSecond] = useState(0);

  const durationCompleted = media?.currentTime && Number(playingPodcast?.length) / 1000 <= media?.currentTime;

  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.key == " " || event.code == "Space") && media) {
      media?.playPause();
    }
  };

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    if (handlePlayPodcast) {
      if (media?.isPlaying) {
        setPlayingPodcast(null);
      }
      handlePlayPodcast();
    } else {
      if (media) {
        if (durationCompleted) {
          media.seekTo(0);
        }
        media.playPause();
      }
    }
    if (cancel) {
      if (media?.isPlaying) {
        media.pause();
      }
      setPlayingPodcast(null);
      setPlayPodcast(false);
    }
  };

  const contentCids = playingPodcast?.audio_urls || playingPodcast?.video_urls || [];

  useInterval(
    () => {
      if (contentCids?.length > 0) {
        const cid = contentCids[second];
        port.propagatePoRT([cid]);
        setSecond(prev => prev + 1);
      }
    },
    // Delay in milliseconds or null to stop it
    media?.isPlaying ? 1000 : null
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    if (durationCompleted && media?.isPlaying) {
      media.pause();
    }
    return () => window.removeEventListener("keydown", handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playingPodcast, media, durationCompleted]);

  const showPauseButton = podcastDetails && playingPodcast ? podcastDetails.episode_number === playingPodcast.episode_number : true;

  const IconType = () => {
    if (cancel) {
      return <CancelIcon width="48px" height="48px" />;
    } else if (media?.isPlaying && contentCids && showPauseButton && playPodcast) {
      return <PauseIcon />;
    } else if (expandedPlay) {
      return <PlayFillIcon height="40px" width="40px" />;
    } else {
      return <PlayIcon />;
    }
  };

  const hoverColor = cancel || expandedPlay ? "purple.50" : "";

  return (
    <Button
      bgColor={cancel || expandedPlay ? "transparent" : getPodcastThemeToken(PodcastColorTypes.IconsBackground)}
      width={size}
      height={size}
      borderRadius="50%"
      color={cancel || expandedPlay ? "white" : getPodcastThemeToken(PodcastColorTypes.Icons)}
      onClick={e => {
        handleClick(e);
      }}
      display={{ base: "flex" }}
      __hover={{ backgroundColor: "transparent", color: hoverColor }}
      __active={{ backgroundColor: "transparent", color: hoverColor }}
      zIndex="10"
    >
      {IconType()}
    </Button>
  );
}

export const CustomPlayPause = withMediaProps(TogglePlayPause);
